export default __webpack_public_path__ + "static/media/email-icon.e4e9e6d6.svg";